import { ReactComponent as StrikeIcon } from 'assets/icons/strikethrough24.svg'
import cx from 'classnames'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useStrikethroughToggle } from 'common/Prose/Toolbar/hooks/useStrikethroughToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { observer } from 'mobx-react-lite'
import Styles from '../../MobileToolbar.module.scss'

export const StrikethroughMark = observer((props: ButtonProps) => {
  const view = useEditorView()
  const { active, disabled, handleClick } = useStrikethroughToggle(view)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Set italic"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: active,
        [Styles.disabled]: disabled,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-strikethrough-mark"
      {...props}
    >
      <StrikeIcon />
    </Button>
  )
})
